<lib-search>
    <lib-collections></lib-collections>
    <lib-buffer [bufferHeight]="16"></lib-buffer>
    <!-- <lib-panorama-carousel></lib-panorama-carousel> -->
    <lib-video-carousel></lib-video-carousel>
    <lib-buffer [bufferHeight]="16"></lib-buffer>
    <lib-info-carousel></lib-info-carousel>
    <lib-buffer [bufferHeight]="20"></lib-buffer>
    <!-- <lib-events></lib-events> -->
</lib-search>